"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.postMessageWrapper = exports.MessageTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _avlComponents = require("@availabs/avl-components");

var _api = require("../api");

var _utils = require("../api/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MessageTypes = ["user", "users", "group", "project"];
exports.MessageTypes = MessageTypes;
var InitialState = {
  heading: "",
  message: "",
  type: "",
  target: "",
  filterGroups: []
};

var Reducer = function Reducer(state, action) {
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case "update-state":
      return _objectSpread(_objectSpread({}, state), payload);

    default:
      return state;
  }
};

var postMessageWrapper = function postMessageWrapper(Component) {
  var Wrapper = function Wrapper(_ref) {
    var getUsers = _ref.getUsers,
        getGroups = _ref.getGroups,
        users = _ref.users,
        groups = _ref.groups,
        projectName = _ref.projectName,
        postMessage = _ref.postMessage,
        sendSystemMessage = _ref.sendSystemMessage,
        props = _objectWithoutProperties(_ref, ["getUsers", "getGroups", "users", "groups", "projectName", "postMessage", "sendSystemMessage"]);

    _react["default"].useEffect(function () {
      getUsers();
      getGroups();
    }, [getUsers, getGroups]);

    var _React$useReducer = _react["default"].useReducer(Reducer, InitialState),
        _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
        postState = _React$useReducer2[0],
        dispatch = _React$useReducer2[1];

    var filteredUsers = _react["default"].useMemo(function () {
      var filterGroups = postState.filterGroups;
      var fgMap = filterGroups.reduce(function (a, c) {
        a[c] = true;
        return a;
      }, {});
      return users.filter(function (_ref2) {
        var projects = _ref2.projects;
        return projects.reduce(function (a, c) {
          return a || c.project_name === projectName;
        }, false);
      }).filter(function (_ref3) {
        var groups = _ref3.groups;
        return groups.reduce(function (a, c) {
          return a || fgMap[c];
        }, !Boolean(filterGroups.length));
      }).sort(function (a, b) {
        return a.email.localeCompare(b.email);
      });
    }, [users, projectName, postState]);

    var filteredGroups = _react["default"].useMemo(function () {
      return groups.filter(function (_ref4) {
        var projects = _ref4.projects;
        return projects.reduce(function (a, c) {
          return a || c.project_name === projectName;
        }, false);
      }).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    }, [groups, projectName]);

    var updatePostState = _react["default"].useCallback(function (payload) {
      if ("type" in payload) {
        payload.target = "";
      }

      if (payload.type === "project") {
        payload.target = projectName;
      }

      dispatch({
        type: "update-state",
        payload: payload
      });
    }, [projectName, dispatch]);

    var canPostMessage = _react["default"].useMemo(function () {
      var heading = postState.heading,
          message = postState.message,
          type = postState.type,
          target = postState.target;
      return Boolean(heading && message && type && target);
    }, [postState]);

    var doPostMessage = _react["default"].useCallback(function () {
      if (!canPostMessage) return;
      var heading = postState.heading,
          message = postState.message,
          type = postState.type,
          target = postState.target;
      return postMessage(heading, message, type, target);
    }, [postMessage, postState, canPostMessage]);

    return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
      canPostMessage: canPostMessage,
      postMessage: doPostMessage,
      updatePostState: updatePostState,
      postState: postState,
      users: filteredUsers,
      groups: filteredGroups
    }));
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      messages: state.messages,
      users: state.users,
      groups: state.groups,
      projectName: _utils.Config.PROJECT_NAME
    };
  };

  var mapDispatchToProps = {
    postMessage: _api.postMessage,
    getMessages: _api.getMessages,
    getUsers: _api.getUsers,
    getGroups: _api.getGroups,
    sendSystemMessage: _avlComponents.sendSystemMessage
  };
  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Wrapper);
};

exports.postMessageWrapper = postMessageWrapper;
var _default = postMessageWrapper;
exports["default"] = _default;